import { type HelpWidgetProps } from './HelpWidget.types';

const HelpWidget: React.FC<HelpWidgetProps> = ({
  helpPageText,
  helpPageUrl,
  helpLinks,
}) => {
  if (!helpLinks || helpLinks.length === 0) return;

  return (
    <aside className="help-widget">
      <h2 className="help-widget__title h5">
        <a href={helpPageUrl}>{helpPageText}</a>
      </h2>
      <ul className="help-widget__list">
        {helpLinks.map((link, i) => (
          <li className="help-widget__item" key={i}>
            <a href={link.url} className="help-widget__link">
              {link.title}
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default HelpWidget;
